/**
 * Utils to parse & manipulate numbers
 */

/**
 * Rounds a value representing a percentage to a 2-digits precision
 * Percentages are stored as floats (between 0 and 1), therefore rounds to 4 decimal places
 *
 * @example roundPercentage(0.4578142) // returns 0.4578 (45.78%)
 * @example roundPercentage(0.4578512) // returns 0.4579 (45.79%)
 *
 * @param  {Number} value
 * @return {Number} the value rounded to 4 decimal places at most
 */
const roundPercentage = (value) => parseFloat(value.toFixed(4));

/**
 * Round a value representing a currency to a 2-digits precision
 * Currencies are stored in cents, therefore rounds to 0 decimal places
 *
 * @example roundCurrency(78541.428) // returns 78541
 * @example roundCurrency(78541.534) // returns 78542
 *
 * @param  {Number} value
 * @return {Number} the value rounded to 0 decimal places
 */
const roundCurrency = (value) => Math.round(value);

export { roundPercentage, roundCurrency };
